const mixin = {
  computed: {
    formColumn() {
      return [
        {
          prop: 'spaceCompanyNo',
          name: '公司：',
          type: 'select',
          placeholder: '请选择',
          changeMethod: 'changeCompany',
          options: this.companyList,
          span: 6,
        },
        {
          prop: 'spaceAreaNo',
          name: '片区：',
          type: 'select',
          placeholder: '请选择',
          value: 'spaceNo',
          label: 'label',
          options: [{ label: '全部', value: '' }, ...this.districtList],
          changeMethod: 'refreshDistrict',
          span: 6,
        },
        {
          prop: 'spaceAssetNo',
          name: '资产：',
          type: 'select',
          value: 'spaceNo',
          label: 'label',
          placeholder: '请选择',
          options: [{ label: '全部', value: '' }, ...this.assetsList],
          span: 6,
        },
        {
          prop: 'name',
          name: '空间名称：',
          type: 'input',
          placeholder: '请输入',
          span: 6,
        },
        {
          prop: 'type',
          name: '类型：',
          type: 'select',
          placeholder: '请选择',
          options: [{ label: '全部', value: '' }, ...this.dictListMap['search-type']],
          span: 6,
        },
        {
          prop: 'auditStatus',
          name: '状态：',
          type: 'select',
          placeholder: '请选择',
          options: [{ label: '全部', value: '' }, ...this.dictListMap['audit-state']],
          span: 6,
        },
        {
          prop: 'createPersonName',
          name: '申请人：',
          type: 'input',
          placeholder: '请输入',
          span: 6,
        },

        {
          prop: 'dateStart',
          name: '开始时间',
          type: 'startDaterangePicker',
          format: 'yyyy-mm-dd',
        },
        {
          prop: 'dateEnd',
          name: '结束时间',
          type: 'endDaterangePicker',
          format: 'yyyy-mm-dd',
        },
      ];
    },
  },
  watch: {},
  data() {
    return {
      districtList: [],
      assetsList: [],
      lastModifyId: '',
      columnListDefault: [
        {
          type: 'checkbox',
          visible: true,
          width: '50',
          fixed: 'left',
        },
        {
          field: 'applicationNo',
          title: '申请编号',
          visible: true,
        },
        {
          field: 'spaceCompanyName',
          title: '公司',
          visible: true,
        },
        {
          field: 'spaceAreaName',
          title: '片区',
          visible: true,
        },
        {
          field: 'spaceAssetName',
          title: '资产',
          visible: true,
        },
        {
          field: 'spaceNo',
          title: '空间编号',
          visible: true,
        },
        {
          field: 'spaceName',
          title: '空间名称',
          visible: true,
        },
        {
          field: 'area',
          title: '面积（㎡）',
          visible: true,
        },
        {
          field: 'newSelfUseFlag',
          title: '是否自用',
          visible: true,
        },
        {
          field: 'type',
          title: '类型',
          visible: true,
        },
        {
          field: 'auditStatus',
          title: '审核状态',
          visible: true,
        },
        {
          field: 'createPersonName',
          title: '申请人',
          visible: true,
        },
        {
          field: 'gmtCreate',
          title: '申请时间',
          visible: true,
        },
      ],
    };
  },
  mounted() {
    this.getCompany();
  },
  methods: {
    initFormColumn() {
      this.districtList = [];
      console.log(this.treeData);
      for (let i = 0; i < this.treeData.length; i++) {
        this.districtList.push(this.treeData[i]);
      }
    },
    searchValue(id, data, list) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].spaceNo == id) {
          if (data[i].children.length > 0) {
            for (let j = 0; j < data[i].children.length; j++) {
              list.push(data[i].children[j]);
            }
          }
        } else {
          if (data[i].children.length > 0) {
            this.searchValue(id, data[i].children, list);
          }
        }
      }
    },
    refreshDistrict(value) {
      this.assetsList = [];
      this.queryFormData.spaceAssetNo = '';
      this.searchValue(value.val, this.treeData, this.assetsList);
      console.log('测试数据', value, this.assetsList);
      this.lastModifyId = value.val;
    },
  },
};
export default mixin;
